import { render } from "./FeedbackBanner.vue?vue&type=template&id=5b06b8e1"
import script from "./FeedbackBanner.vue?vue&type=script&lang=js"
export * from "./FeedbackBanner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__